import { queryOptions } from "@tanstack/react-query";
import { getSidoList, getSigunguList } from "../v1/region.service";

export const useSidoList = () =>
  queryOptions({
    queryKey: ["region-sido-list"],
    queryFn: () => getSidoList(),
    retry: 1,
  });

export const useSigunguList = (sidoCode: string) =>
  queryOptions({
    queryKey: ["region-sigungu-list", sidoCode],
    queryFn: () => getSigunguList(sidoCode),
    enabled: !!sidoCode,
    retry: 1,
  });
